import React, { useContext } from "react";
import BatchOrders from "../BatchOrders/BatchOrders";
import { SocketContext } from "../../../contexts/SocketContext";
import UserContext from "../../../contexts/UserContext";
import SupplierContext from "../../../contexts/SupplierContext";
import VendorContext from "../../../contexts/VendorContext";
import UiContext from "../../../contexts/UiContext";
import { useLocation, useNavigate } from "react-router-dom";

type Props = {};

export const BatchOrdersWrapper = (props: Props) => {
    const socket = useContext(SocketContext)!;

    const userModel = useContext(UserContext);
    const supplierModel = useContext(SupplierContext);
    const vendorModel = useContext(VendorContext);

    const uiContext = useContext(UiContext);

    const navigate = useNavigate();
    const location = useLocation();

    return (
        <BatchOrders
            setActivityIndicator={uiContext.setActivityIndicator}
            setSidebarComponent={uiContext.setSidebarComponent}
            supplierModel={supplierModel}
            toggleSidebar={uiContext.toggleSidebar}
            userModel={userModel}
            socket={socket}
            location={location}
            history={navigate}
            notifyFn={uiContext.notifyFn}
        />
    );
};
